// Types
import type { TApiHttpClientRequestConfig, TPaginationRequest } from '~/misc/resource/types';
import type {
  IPatchResourceModel,
  TNewPatch,
  TPaginatedPatches,
  TPatch,
  TPatchIdsPayload,
} from '~/misc/patch/types';

// Models
import { DefaultResource } from '~/misc/resource/default-resource.model';

// TODO: drop all methods except `index` https://addintel.atlassian.net/browse/RC-599
export class PatchModel extends DefaultResource implements IPatchResourceModel {
  protected endpoint = 'patches/';

  index(
    payload?: TPaginationRequest,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPaginatedPatches> {
    return this.get<TPaginatedPatches>('', payload, requestConfig);
  }

  ids(payload?: TPatchIdsPayload, requestConfig?: TApiHttpClientRequestConfig): Promise<number[]> {
    return this.get<number[]>('ids', payload, requestConfig);
  }

  store(payload: TNewPatch, requestConfig?: TApiHttpClientRequestConfig): Promise<TPatch> {
    return this.post<TPatch>('', payload, requestConfig);
  }

  update(
    id: number,
    payload: TNewPatch,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPatch> {
    return this.put<TPatch>(`${id}`, payload, requestConfig);
  }

  destroy(id: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.delete<void>(`${id}`, undefined, requestConfig);
  }
}
